import React, { useState, useEffect } from 'react';
import Navbar from '../components/Navbar';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

function Home() {
  return (
    <main className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-gray-900 to-black text-white px-4">
      <motion.div
        initial={{ opacity: 0, y: -30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
        className="text-center"
      >
        <h1 className="text-4xl md:text-6xl font-extrabold mb-4 text-green-400">
          Welcome to MyWebUniversity
        </h1>
        <p className="text-lg md:text-xl text-gray-300 max-w-2xl mx-auto mb-8">
          Explore hands-on tutorials and videos about Linux, AI, Machine Learning,
          Software Development, and more — in both English and Farsi (Dari).
        </p>
      <div className="flex flex-wrap justify-center gap-4">
          <div>
          <Link
            to="/courses"
            className="px-6 py-3 bg-green-500 hover:bg-red-600 text-white rounded-2xl shadow-lg transition-all"
          >
            Explore Courses
          </Link>
          </div>

          <div>
          <a
            href="https://youtube.com/@MyWebUniversity"
            target="_blank"
            rel="noopener noreferrer"
            className="px-6 py-3 bg-red-500 hover:bg-green-600 text-white rounded-2xl shadow-lg transition-all"
          >
            Visit YouTube Channel In English 
          </a>
          </div>
          <div>
          <a
            href="https://youtube.com/@MyWebUniversity-In-Farsi"
            target="_blank"
            rel="noopener noreferrer"
            className="px-6 py-3 bg-red-500 hover:bg-green-600 text-white rounded-2xl shadow-lg transition-all"
          >
            Visit YouTube Channel In Farsi (Dari)
          </a>
        </div>
          <br />
          <br />
        <div>
          <a
            href="https://www.MyWebUniversity.com/toc1.html"
            target="_blank"
            rel="noopener noreferrer"
            className="px-6 py-3 bg-green-500 hover:bg-red-600 text-white rounded-2xl shadow-lg transition-all"
          >
           The Direct Path To Linux Ubuntu 
          </a>
          </div>

          <br />
          <br />
          <div>
          <a
            href="https://www.MyWebUniversity.com/JavaScripts/index.html"
            target="_blank"
            rel="noopener noreferrer"
            className="px-6 py-3 bg-blue-500 hover:bg-red-600 text-white rounded-2xl shadow-lg transition-all"
          >
           Practice and Learn Simple Arithmetic/Math 
          </a>
        </div>
      </div>
      </motion.div>
    </main>
  );
}
export default Home;
